import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsDoneWorksCosts: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COSTS,
	},
	getReportsDoneWorksCost: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COST,
	},
  getReportsDoneWorksCostPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COST_PREVIEW,
	},
}